import { render, staticRenderFns } from "./NotificationsSettingsFormProducts.vue?vue&type=template&id=5bfe5094"
import script from "./NotificationsSettingsFormProducts.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports